import LiquidationModel from './liquidation';
import DissolutionModel from './dissolution';
import TransmissionModel from './transmission';

export default [
  LiquidationModel,
  DissolutionModel,
  TransmissionModel
];